'use client'

import { useState } from 'react'
import { useRouter } from 'next/navigation'

export default function EquipButton({ userCosmeticId, isEquipped }: { userCosmeticId: string, isEquipped: boolean }) {
  const [loading, setLoading] = useState(false)
  const router = useRouter()

  const handleToggle = async () => {
    setLoading(true)
    try {
      const res = await fetch('/api/store/equip', {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ userCosmeticId, isEquipped: !isEquipped })
      })

      if (!res.ok) throw new Error('Failed to update equipment')
      router.refresh()
    } catch (error) {
      alert('Error updating equipment')
    } finally {
      setLoading(false)
    }
  }

  return (
    <button
      onClick={handleToggle}
      disabled={loading}
      className={`px-3 py-1.5 rounded-lg text-xs font-bold transition-all ${
        isEquipped 
          ? 'bg-emerald-500/20 text-emerald-400 border border-emerald-500/40' 
          : 'bg-slate-800 hover:bg-slate-700 text-slate-300'
      } disabled:opacity-50`}
    >
      {loading ? '...' : isEquipped ? 'Equipped' : 'Equip'}
    </button>
  )
}
